var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.5L12.1692 12.1692M12.1692 12.1692C13.3413 10.997 13.9998 9.40726 13.9998 7.74959C13.9998 6.09193 13.3413 4.50216 12.1692 3.33001C10.997 2.15786 9.40725 1.49936 7.74958 1.49936C6.09192 1.49936 4.50215 2.15786 3.33 3.33001C2.15785 4.50216 1.49935 6.09193 1.49935 7.74959C1.49935 9.40726 2.15785 10.997 3.33 12.1692C4.50215 13.3413 6.09192 13.9998 7.74958 13.9998C9.40725 13.9998 10.997 13.3413 12.1692 12.1692Z",
    stroke: "#91918F",
    strokeWidth: 1.74,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.e1c02236f2821c22b6ac4e285146ca6b.svg";
export { ForwardRef as ReactComponent };